<template>
  <div class="profile-gift-container">
    <category-block
      :target="category"
      position="position1"
      class="category-block category-block-1"
    />

    <CategoryTitle :category="category" />

    <template
      v-if="
        (filteredAutoAssignedGifts && filteredAutoAssignedGifts.length > 0) ||
          (filteredManualAssignedGifts &&
            filteredManualAssignedGifts.length > 0)
      "
    >
      <GiftList
        v-if="filteredAutoAssignedGifts.length > 0"
        :giftList="filteredAutoAssignedGifts"
        @reload="reload"
      />
      <GiftList
        v-if="filteredManualAssignedGifts.length > 0"
        :giftList="filteredManualAssignedGifts"
        @reload="reload"
      />
    </template>
    <div v-else-if="!loading" class="empty-gifts">
      {{ $t("profile.gifts.emptyGifts") }}
    </div>

    <category-block
      :target="category"
      position="position2"
      class="category-block category-block-2"
    />

    <!-- Invita un amico -->
  </div>
</template>
<style lang="scss">
.profile-gift-container {
  .invite-card {
    height: 210px;
    @media #{map-get($display-breakpoints, 'xs-only')} {
      height: auto;
    }
    .v-image {
      @media #{map-get($display-breakpoints, 'xs-only')} {
        border-bottom-left-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
      }
      @media #{map-get($display-breakpoints, 'sm-and-up')} {
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
      }
    }
  }
}
</style>
<script>
import { mapGetters } from "vuex";
import CategoryTitle from "@/components/category/CategoryTitle.vue";

import GiftList from "@/components/gift/GiftList.vue";
import login from "~/mixins/login";
import category from "~/mixins/category";
import deliveryReactive from "~/mixins/deliveryReactive";
import { mapProposalComponent } from "@/commons/service/ebsn";
import userService from "~/service/userService";
import get from "lodash/get";

export default {
  name: "ProfileGift",
  mixins: [category, deliveryReactive, login],
  components: { CategoryTitle, GiftList },
  data() {
    return {
      loading: true,
      autoAssignedGifts: [],
      manualAssignedGifts: []
    };
  },
  computed: {
    ...mapGetters({
      user: "cart/getUser"
    }),
    ...mapProposalComponent({
      header: "header",
      footer: "footer"
    }),
    filteredAutoAssignedGifts() {
      return this.autoAssignedGifts.filter(
        gift =>
          !get(
            gift,
            "categoryProposal.metaData.category_proposal_type.HIDE_IN_LIST"
          ) == true
      );
    },
    filteredManualAssignedGifts() {
      return this.manualAssignedGifts.filter(
        gift =>
          !get(
            gift,
            "categoryProposal.metaData.category_proposal_type.HIDE_IN_LIST"
          ) == true
      );
    }
  },
  methods: {
    async reload() {
      try {
        this.loading = true;
        this.autoAssignedGifts = await userService.listGiftCertificate("auto");
        this.manualAssignedGifts = await userService.listGiftCertificate(
          "manual"
        );
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.reload();
  }
};
</script>
